import React, { useCallback } from "react";
import { Pagination, Select, Space, Typography } from "antd";
import { t } from "i18next";

const { Text } = Typography;

export default function CommonPagination(props) {
  const { isPaginationWithCount = true, paginationOptions, filter, setFilter, data, setPaginationAction } = props;

  const handlePageChange = useCallback(
    (page, action) => {
      setPaginationAction(action);
      setFilter({ ...filter, page: page });
    },
    [filter]
  );

  const handleLimitChange = useCallback(
    (size) => {
      setFilter({ ...filter, pageSize: size });
    },
    [filter]
  );

  const total = data?.count || 0;
  const current = filter.page;
  const pageSize = filter.pageSize;

  const showTotal = (total, range) => (
    <Space size="small" align="center">
      <Text>
        {t("common.CommonTable.Showing")} {range[0]} - {range[1]} {t("common.CommonTable.of")} {total}{" "}
        {t("common.CommonTable.results, at most")}
      </Text>
      <Select
        size="small"
        value={String(pageSize)}
        onChange={(value) => handleLimitChange(Number(value))}
        options={(paginationOptions || ["10", "15", "25", "30", "50", "150"]).map((option) => ({
          label: option,
          value: option,
        }))}
        style={{ width: 80 }}
      />
      <Text>{t("common.CommonTable.per page")}</Text>
    </Space>
  );

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "16px 0" }}>
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        showSizeChanger={false}
        showTotal={isPaginationWithCount ? showTotal : false}
        onChange={(page) => handlePageChange(page, page > current ? "next" : "previous")}
        showQuickJumper
        size="default"
      />
    </div>
  );
}
